import { getLogLevel } from './utils';
var LogLevel = {
    debug: 'debug',
    info: 'info',
    error: 'error',
    warn: 'warn',
};
export var getDatadogLevelFromPinoLevel = function (logLevel) { return LogLevel[logLevel] || LogLevel.error; }; // Default to error if unknown
export var generateDefaultOptions = function (logLevel, datadog) {
    var _a;
    return {
        browser: {
            asObject: true,
            serialize: true,
            transmit: {
                send: function (level, logEvent) {
                    if (datadog === null || datadog === void 0 ? void 0 : datadog.clientToken) {
                        var ddLogs_1 = window === null || window === void 0 ? void 0 : window.DD_LOGS;
                        if (ddLogs_1) {
                            ddLogs_1.onReady(function () {
                                var logger = ddLogs_1.logger;
                                var loggerLevel = getDatadogLevelFromPinoLevel(level);
                                var message = logEvent.messages[0];
                                if (logger[loggerLevel]) {
                                    logger[loggerLevel](message);
                                }
                            });
                        }
                    }
                },
            },
        },
        level: (_a = getLogLevel(logLevel)) !== null && _a !== void 0 ? _a : LogLevel.info,
    };
};
